import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { AppBar, Typography, Grid } from '@material-ui/core';
import { Table, TableRow, TableCell, TableHead, TableBody } from '@material-ui/core';
import { Menu, MenuItem, IconButton } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import * as Actions from '../store/actions';
import ChoiceAnswer from './questionType/ChoiceAnswer';
import TextAnswer from './questionType/TextAnswer';
import OrderAnswer from './questionType/OrderAnswer';
import HotSpotAnswer from './questionType/HotSpotAnswer';

class StudentQuestion extends Component {
    state = {
        menuAnchor: null
    }
    
    openMenu = (event) => {
        this.setState({
            ...this.state,
            menuAnchor: event.currentTarget
        });
    }

    closeMenu = (event) => {
        this.setState({
            ...this.state,
            menuAnchor: null
        });
    }

    handleMenuClick = (question_index) => (event) => {
        this.props.setQuestion(question_index);

        this.closeMenu(event);
    }

    getAnswerContent = (question) => {
        const question_type_id = question.header.question_type_id;
        
        switch(question_type_id)
        {
            case(1): // Multiple Choice
            case(4): // Multiple Answer
            {
                return (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2}>{question_type_id === 4 ? 'Mark all that Apply' : ''}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {question.answerList.map((answer) =>
                                <ChoiceAnswer
                                    key={answer.header.answer_id}
                                    answer={answer}
                                    question={question}
                                />
                            )}
                        </TableBody>
                    </Table>
                );
            }
            case(2): // Short Answer
            case(3): // Long Answer
            {
                return (
                    <TextAnswer
                        answer={question.answerList[0]}
                        question={question}
                    />
                );
            }
            case(5): // Order Answer
            {
                return (
                    <OrderAnswer
                        question={question}
                    />
                );
            }
            case(6): // Hotspot Answer
            {
                return (
                    <HotSpotAnswer
                        question={question}
                    />
                )
            }

            default: {}
        }
    }

    render() {
        const { question, index, setQuestion, quiz } = this.props;
        const { menuAnchor } = this.state;

        if (typeof question === 'undefined') {
            return <div>Loading Question...</div>;
        }

        const answerContent = this.getAnswerContent(question);

        return (
            <Grid container>
                <AppBar position="static">
                    <div className="p-16 pr-4 flex flex-row items-center justify-between">
                        <Typography className="h1 pr-16" color="inherit">#{index + 1} - {question.header.QuestionText}</Typography>

                        <IconButton
                            color="inherit"
                            aria-label="More"
                            aria-owns={menuAnchor ? 'long-menu' : null}
                            aria-haspopup="true"
                            onClick={this.openMenu}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        
                        <Menu
                            id="menu-appbar"
                            anchorEl={menuAnchor}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(menuAnchor)}
                            onClose={this.closeMenu}
                        >
                            {quiz.questionList.map((question, index) => 
                                <MenuItem key={question.header.question_id} onClick={this.handleMenuClick(index)}>{"Question #" + (index + 1)}</MenuItem>
                            )}
                        </Menu>
                    </div>
                </AppBar>

                <Grid item xs={12}>
                    {answerContent}
                </Grid>
            </Grid>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setQuestion: Actions.setQuestion,
    }, dispatch);
}

function mapStateToProps({ quizApp, timer }) {
    return {
        quiz:           quizApp.quizzes.currentQuiz,
        studentAnswers: quizApp.quizViewer.studentAnswers,
        timeTaken:      timer.timeTaken,
    }
}

export default withStyles(null, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentQuestion)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizViewer/StudentQuestion.js